import TrainsTypeaheadBaseController from '../../trains-base/controllers/trains-typeahead-base-controller';

export default function TrainsTypeaheadController(
    $scope,
    $controller
) {
    'ngInject';

    $controller(TrainsTypeaheadBaseController, {
        $scope,
        cfg: {
            searchLocationsUrl: '/staticdata/SearchEurostarStations',
        },
    });
}



// WEBPACK FOOTER //
// ./src/app/modules/train/controllers/trains-typeahead-controller.js